import { initReactI18next } from 'react-i18next';

import { logger } from 'common/services/logger';
import { isProduction, isTest } from 'common/utils/environment';
import i18n from 'i18next';
import { defaultNS, ns, resources } from 'locales/en';

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: !isProduction() && !isTest(),
    defaultNS,
    resources,
    ns,
    interpolation: {
      escapeValue: false,
    },
  })
  .catch(() => {
    logger.error('[i18n] initialization failed');
  });

export default i18n;
